var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9535 15.7499C13.2369 17.2681 11.0058 18.0742 8.71528 18.0039C6.42476 17.9337 4.2473 16.9923 2.62697 15.3718C1.00664 13.7514 0.065478 11.5738 -0.00457838 9.28331C-0.0746347 6.99278 0.731691 4.76179 2.24996 3.04532L6.18746 6.98282V13.4999H7.63084V10.3094H9.51409L14.9535 15.7499ZM15.75 14.9534L10.8337 10.0372C11.8125 9.58945 12.375 8.6197 12.375 7.41032C12.375 5.74307 11.3006 4.50332 9.51971 4.50332H6.18746V5.39207L3.04646 2.2522C4.76343 0.737848 6.99298 -0.0652592 9.28124 0.00636264C11.5695 0.0779845 13.7444 1.01895 15.3634 2.63771C16.9823 4.25648 17.9234 6.43135 17.9952 8.7196C18.0671 11.0079 17.2642 13.2375 15.75 14.9546V14.9534Z",
    fill: "url(#paint0_linear_4847_63929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63929",
    x1: -0.00878906,
    y1: 0.00195312,
    x2: 18.3668,
    y2: 0.384786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoParking);
export default __webpack_public_path__ + "static/media/no-parking.f309461e584c8c50e26605ae91abdac9.svg";
export { ForwardRef as ReactComponent };